
import React from "react";
import { UserRole } from "./user-roles";
import useAuth from "./useAuth";

type ProtectedRouteProps = {
    children: JSX.Element;
    allowedRoutes: UserRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = (props) => {
    let { isLoggedIn, user, isInRole } = useAuth();
    if (!user)
        return null;

  //  console.log("ProtectedRoute", user, isLoggedIn, props.allowedRoutes);
 
    if (!isLoggedIn || !user || !(!!props.allowedRoutes && props.allowedRoutes.length > 0 && !!isInRole(props.allowedRoutes))) {

        return null;
    }


    return props.children;
}
